// Lote 110 (pedido do Robson, 24/10/2026) — prazo padrão e calculadora dentro do Novo evento.
// A conta em si é do servidor (/prazos/calcular: mesmos feriados nacionais da Calculadora de prazos,
// sem feriados estaduais/municipais); aqui ficam as constantes e a leitura dos "N dias" do texto.
import { http } from "@/lib/api";

export const PRAZO_PADRAO_DIAS = 5;
export const PRAZO_PADRAO_HORA = "18:00";

export async function calcularPrazo({ dataIso, dias, regime = "uteis", base = "ciencia", recesso = false }) {
  const { data } = await http.post("/prazos/calcular", {
    data_ato: dataIso, dias, regime, base, excluir_feriados: true, excluir_recesso: recesso,
  });
  return data;
}

const NUMEROS = {
  um: 1, uma: 1, dois: 2, duas: 2, tres: 3, "três": 3, quatro: 4, cinco: 5, seis: 6, sete: 7, oito: 8, nove: 9,
  dez: 10, onze: 11, doze: 12, treze: 13, quatorze: 14, catorze: 14, quinze: 15, dezesseis: 16, dezessete: 17,
  dezoito: 18, dezenove: 19, vinte: 20, trinta: 30, quarenta: 40, sessenta: 60, noventa: 90,
};
const PALAVRAS = Object.keys(NUMEROS).sort((a, b) => b.length - a.length).join("|");
// "5 dias", "05 (cinco) dias úteis", "quinze dias", "quinze (15) dias corridos"
const RE_DIAS = new RegExp(`(?:(\\d{1,3})|\\b(${PALAVRAS}))\\s*(?:\\([^)]{1,25}\\)\\s*)?dias?\\b(\\s+(?:úteis|uteis|corridos))?`, "gi");

/** Procura "N dias" no texto. Devolve até 4 sugestões únicas: [{ dias, regime|null, trecho }]. */
export function sugerirDias(text) {
  const t = String(text || "");
  const out = [];
  const seen = new Set();
  let m;
  RE_DIAS.lastIndex = 0;
  while ((m = RE_DIAS.exec(t)) && out.length < 4) {
    const dias = m[1] ? parseInt(m[1], 10) : NUMEROS[m[2].toLowerCase()];
    if (!dias || dias < 1 || dias > 180) continue;
    const reg = (m[3] || "").toLowerCase();
    const regime = reg.includes("corr") ? "corridos" : reg.includes("ute") || reg.includes("út") ? "uteis" : null;
    const k = `${dias}|${regime}`;
    if (seen.has(k)) continue;
    seen.add(k);
    out.push({ dias, regime, trecho: t.slice(Math.max(0, m.index - 25), m.index + m[0].length).replace(/\s+/g, " ").trim() });
  }
  return out;
}
